<nav class="navbar navbar-light bg-light navbar-expand-lg">
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <form class="form-inline my-2 my-lg-0 ms-3 me-2">
      <input id="busquedaFormControl" type="text" class="form-control" [formControl]="busquedaFormControl"
        placeholder="Cliente/Aerovale/Factura/Legajo" (input)="filtrarLegajos()" />
    </form>

    <ul class="navbar-nav me-auto align-items-center">
      <li class="nav-item me-2">
        <select class="form-select" [(ngModel)]="tipoSeleccionado" name="tipo">
          <option *ngFor="let tipo of tiposBusqueda" [ngValue]="tipo.value">
            {{ formatLabel(tipo.key) }}
          </option>
        </select>
      </li>

      <li class="nav-item me-2">
        <div class="input-group">
          <input type="date" [ngModel]="modelDesde" class="form-control form-control-rounded"
            (ngModelChange)="modelDesde = $event; onDesdeChange()" name="dt" ngbDatepicker #d="ngbDatepicker" required
            readonly>
          <button id="botonDesde" type="button" class="btn btn-secondary" (click)="d.toggle()">
            <i class="fa fa-calendar" aria-hidden="true"></i>
          </button>
        </div>
      </li>

      <li class="nav-item me-2">
        <div class="input-group">
          <input type="date" [ngModel]="modelHasta" class="form-control form-control-rounded"
            (ngModelChange)="modelHasta = $event" name="dp" [minDate]="minFechaHasta" [maxDate]="maxFechaHasta"
            ngbDatepicker #h="ngbDatepicker" required readonly>
          <button id="botonHasta" type="button" class="btn btn-secondary" (click)="h.toggle()">
            <i class="fa fa-calendar" aria-hidden="true"></i>
          </button>
        </div>
      </li>

      <li class="nav-item">
        <button class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" [disabled]="cargandoLista"
          (click)="buscarDesdeHasta()">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </li>

      <li class="nav-item">
        <button *ngIf="legajosFiltradosMultifiltro.length > 0" (click)="descargarExcel()"
          class="btn btn-primary me-2 my-2">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i> Descargar Excel
        </button>
      </li>
    </ul>
  </div>
</nav>

<div class="row mt-3">
  <div class="col-md-12">
    <div class="spinner-container" *ngIf="cargandoLista">
      <ngx-spinner name="spinnerGrafico" [ngStyle]="{'height': '400px', 'z-index':'0'}" bdOpacity=0.3bd
        Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
        <p style="color: white">C a r g a n d o . . . </p>
      </ngx-spinner>
    </div>
  </div>

  <div class="abs-center" *ngIf="!cargandoLista && primerLlamado && legajosFiltrados.length==0">
    <ngb-alert type="warning"> No se encontraron facturas registradas para el rango de fechas seleccionado.
    </ngb-alert>
  </div>

  <div class="tabla-legajos card-body" *ngIf="!cargandoLista && legajosFiltrados.length > 0">
    <table class="table table-striped table-hover">
      <thead class="text-center">
        <tr>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="legajoMultiFiltro"
              (elementosChange)="recargarItems('legajoMultiFiltro', $event)" [nombreAtributo]="'legajo'"
              [encabezadoColumna]="'Legajo'">
            </app-item-multifiltro>
          </th>
          <th>Fecha</th>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="facturaMultiFiltro"
              (elementosChange)="recargarItems('facturaMultiFiltro', $event)" [nombreAtributo]="'factura'"
              [encabezadoColumna]="'Factura'">
            </app-item-multifiltro>
          </th>
          <th>Fecha Factura</th>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="aerovaleMultiFiltro"
              (elementosChange)="recargarItems('aerovaleMultiFiltro', $event)" [nombreAtributo]="'aerovale'"
              [encabezadoColumna]="'Aerovale'">
            </app-item-multifiltro>
          </th>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="clienteMultiFiltro"
              (elementosChange)="recargarItems('clienteMultiFiltro', $event)" [nombreAtributo]="'cliente'"
              [encabezadoColumna]="'Cliente'">
            </app-item-multifiltro>
          </th>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="cuentaMultiFiltro"
              (elementosChange)="recargarItems('cuentaMultiFiltro', $event)" [nombreAtributo]="'cuenta'"
              [encabezadoColumna]="'Cuenta'">
            </app-item-multifiltro>
          </th>
          <th>
            <app-item-multifiltro [decoratorFn]="obtenerTipoSolicitud" [lista]="legajosFiltrados"
              [elementos]="tipoSolicitudMultiFiltro" (elementosChange)="recargarItems('tipoSolicitudMultiFiltro', $event)"
              [nombreAtributo]="'tipoSolicitudRefacturacion'" [encabezadoColumna]="'Tipo Solicitud'">
            </app-item-multifiltro>
          </th>
          <th>
            <app-item-multifiltro [decoratorFn]="obtenerMotivo" [lista]="legajosFiltrados"
              [elementos]="motivoMultiFiltro" (elementosChange)="recargarItems('motivoMultiFiltro', $event)"
              [nombreAtributo]="'motivoRefacturacion'" [encabezadoColumna]="'Motivo'">
            </app-item-multifiltro>
          </th>
          <th>
            <app-item-multifiltro [decoratorFn]="obtenerEstado" [lista]="legajosFiltrados"
              [elementos]="estadoMultiFiltro" (elementosChange)="recargarItems('estadoMultiFiltro', $event)"
              [nombreAtributo]="'estado'" [encabezadoColumna]="'Estado'">
            </app-item-multifiltro>
          </th>
          <th>Notas</th>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="solicitanteMultiFiltro"
              (elementosChange)="recargarItems('solicitanteMultiFiltro', $event)" [nombreAtributo]="'solicitante'"
               [encabezadoColumna]="'Solicitante'">
            </app-item-multifiltro>
          </th>
          <th>Fecha</th>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="validacionComercialMultiFiltro"
              (elementosChange)="recargarItems('validacionComercialMultiFiltro', $event)"
              [nombreAtributo]="'validacionComercial'" 
              [encabezadoColumna]="'Validación Comercial'">
            </app-item-multifiltro>
          </th>
          <th>Fecha </th>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="validadorFacturacionMultiFiltro"
              (elementosChange)="recargarItems('validadorFacturacionMultiFiltro', $event)"
              [nombreAtributo]="'validadorFacturacion'" 
              [encabezadoColumna]="'Validador Facturación'">
            </app-item-multifiltro>
          </th>
          <th>Fecha</th>
          <th>
            <app-item-multifiltro [lista]="legajosFiltrados" [elementos]="aprobadorMultiFiltro"
            (elementosChange)="recargarItems('aprobadorMultiFiltro', $event)"
            [nombreAtributo]="'aprobador'"
            [encabezadoColumna]="'Aprobador'">
            </app-item-multifiltro>
          </th>
          <th>Fecha</th>
          <th>Adjunto</th>
        </tr>
      </thead>
      <tbody class="text-center" style="vertical-align: middle;">
        <tr *ngFor="let s of legajosFiltradosMultifiltro">
          <td>{{ s.legajo }}</td>
          <td>{{ s.fecha ? (s.fecha | date: "dd/MM/yyyy HH:mm") : "--"}}</td>
          <td>{{ s.factura }}</td>
          <td>{{ s.fechaFactura ? (s.fechaFactura | date: "dd/MM/yyyy HH:mm") : "--" }}</td>
          <td>{{ s.aerovale }}</td>
          <td>{{ s.cliente }}</td>
          <td>{{ s.cuenta }}</td>
          <td>{{ obtenerTipoSolicitud(s.tipoSolicitudRefacturacion) }}</td>
          <td>{{ obtenerMotivo(s.motivoRefacturacion)}}</td>
          <td>{{ s.estado ? obtenerEstado(s.estado) : "--"}}</td>
          <td>{{ s.notaCredito ? s.notaCredito : "--" }}</td>
          <td>{{ s.solicitante ? s.solicitante : "--"}}</td>
          <td>{{ s.fechaSolicitante ? (s.fechaSolicitante | date: "dd/MM/yyyy HH:mm") : "--" }}</td>
          <td>{{ s.validacionComercial ? s.validacionComercial : "--"}}</td>
          <td>{{ s.fechaValidacionComercial ? (s.fechaValidacionComercial | date: "dd/MM/yyyy HH:mm") : "--" }}</td>
          <td>{{ s.validadorFacturacion ? s.validadorFacturacion : "--" }}</td>
          <td>{{ s.fechaValidadorFacturacion ? (s.fechaValidadorFacturacion | date: "dd/MM/yyyy HH:mm") : "--"}}</td>
          <td>{{ s.aprobador ? s.aprobador : "--"}}</td>
          <td>{{ s.fechaAprobador ? (s.fechaAprobador | date: "dd/MM/yyyy HH:mm") : "--"}}</td>
          <td>
            <button *ngIf="s.adjunto!=null" class="btn" placement="bottom" ngbTooltip="Descargar Adjunto"
              container="body">
              <a class="fa fa-download" [href]="s.adjunto"></a>
            </button>
            <div *ngIf="s.adjunto===null">--</div>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
</div>